import React, { ChangeEvent } from "react";
import {
  Table, Input, Row, Col, Pagination, Button, Spin, notification, Modal, 
  Popconfirm, Breadcrumb, Upload, Select, FormInstance, Form, Cascader, 
  TreeSelect, Space, Empty,
} from "antd";
import { connect } from "react-redux";
import Column from "antd/lib/table/Column";
import { RootStoreModel } from "../../redux/reducers";
import { Unsubscribe } from "redux";
import { Link, RouteComponentProps } from "react-router-dom";
import { ColumnModel, BasicStateForListModel } from "../models";
import { CancelTokenSource, IsCancel } from "../../axios/axios.core";
import { getTagList } from "@axios/api.account";
import { getOrgsOptionsSelector, treeNode } from "@redux/selector";
import {
  getNotice,
  getNoticeList,
  deleteNotice,
  addNotice,
  pushNotice,
  getNoticeGroup
} from "../../axios/api.notice";
import { PlusOutlined,CheckCircleFilled,StopFilled } from "@ant-design/icons";
import { gaEvent } from "../../withTracker"
import { v4 as uuidv4 } from "uuid";
import { TagProps } from "@axios/models";

import { Translation } from "react-i18next";

interface stateModel extends BasicStateForListModel {
  isModalVisible: boolean;
  title: string;
  detail: any;
  status: "Active" | "Disabled";
  search: string;
  id: string;
  appTypeVisible: boolean,
  applyPeople: string
  tags: any[],
  selectId: string
}

interface propsModel extends RouteComponentProps<any, any, any> {
  orgOptions: treeNode[],
}

const mapStatetoProps = (state: RootStoreModel) => ({
  orgOptions: getOrgsOptionsSelector(state),
});

class DocListPage extends React.Component<propsModel, stateModel> {
  formRef = React.createRef<FormInstance>();
  constructor(props: propsModel) {
    super(props);
    this.state = {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      columns: [],
      data: [],
      isModalVisible: false,
      title: "",
      detail: "",
      status: "Active",
      search: "",
      id: "",
      appTypeVisible: false,
      applyPeople: "",
      tags: [],
      selectId: ""
    };
  }

  cancelToken = CancelTokenSource();

  componentDidMount() {
    this.getList();
    this.getTasks();
  }

  componentDidUpdate(prevProps: propsModel) { }

  componentWillUnmount() {
    // this.setState = () => { }
    this.cancelToken.cancel("cancel axios http request");
  }
  getTasks = () => {
    getTagList().then((res) => {

      var dat = this.formatOptions(res)
      console.log("formatOptions", dat);
      this.setState({ tags: dat })
    })
  }
  formatOptions = (tags: TagProps[]) => {
    return tags.map(({ id, key, values }) => {
      return {
        value: id,
        label: key,
        children: values.map((item: any) => ({
          value: item.id,
          label: item.value,
        })),
      };
    });
  }
  onSearch = () => {
    this.getList(1);
  };

  getList = (
    pageIndex = this.state.pageIndex,
    pageSize = this.state.pageSize
  ) => {
    const { search } = this.state;
    this.setState({ loading: true });
    getNoticeList({ pageIndex, pageSize, search }).then((res) => {
      this.setState({
        data: res.dataList,
        loading: false,
        pageSize: res.pageSize,
        pageIndex: res.pageIndex,
        totalCount: res.totalCount,
      });
    }, () => {
      this.setState({
        loading: false,
      });
    });
  };

  onDelete = (id: string) => {
    this.setState({ loading: true });
    deleteNotice(id).then(() => {
      notification.success({ message: <Translation>{t => {return t("已删除")}}</Translation> });
      this.setState({ loading: false });
      this.getList(1);
    });
  };

  onOk = () => {
    const { id, title, detail, status } = this.state;
    this.setState({ loading: true });
    addNotice({
      id: id,
      title: title,
      content: detail,
      status: status,
    }).then(() => {
      notification.success({ message: <Translation>{t => {return t("提交成功")}}</Translation> });
      this.setState({
        id: "",
        loading: false,
        title: "",
        detail: "",
        isModalVisible: false,
      });
      this.getList(1);
    });
  };

  onEdit = (item: any) => {
    const { id, title, content, status } = item;
    this.setState({
      isModalVisible: true,
      id: id,
      title: title,
      detail: content,
      status: status
    });
  };

  onCancel = () => {
    this.setState({
      isModalVisible: false,
      id: "",
      title: "",
      detail: "",
      status: "Active"
    });
  };
  applyGroupOk = () => {
    this.setState({ loading: true })
    this.formRef?.current?.validateFields().then((res) => {
      // if (!res.type) {
      //   this.setState({loading: false})
      //   return notification.warning({message: "未选择适用人群"})
      // }
      var arg: any = {pushType: res.type || 'None'};
      // if (this.state.applyPeople == "Organization") {
      //   arg.organizationIds = [];
      //   arg.organizationIds.push(res.Organization);
      // }
      if (this.state.applyPeople == "Tag") {
        arg.tagValueIds = [];
        res.tags.forEach((item: any) => {
          arg.tagValueIds.push(item.tag[1]);
        });
      }
      pushNotice(this.state.selectId, arg).then(c => {
        notification.success({ message: <Translation>{t => {return t("成功")}}</Translation> })
        this.setState({ loading: false, appTypeVisible: false, applyPeople: "" })
      }, () => {
        this.setState({ loading: false })
        notification.error({ message: <Translation>{t => {return t("失败")}}</Translation> })
      })

    })

  }

  getAppSelfService = (id: string) => {
    this.setState({loading: true});
    getNoticeGroup(id).then(
      res => {
        // 先渲染出模态框
        this.setState({ appTypeVisible: true, selectId: id, applyPeople: res.pushType });
        // 再更新formRef
        this.formRef.current?.setFieldsValue({
          type: res.pushType,
          Organization: res.organizationIds[0],
          tags: res.tags
        });
      },
      () => {
        notification.error({message: <Translation>{t => {return t("获取自助服务失败")}}</Translation>});
      }
    ).finally(
      () => {
        this.setState({loading: false});
      }
    )
  }

  render() {
    const {
      loading,
      data,
      pageSize,
      pageIndex,
      totalCount,
      isModalVisible,
      title,
      detail,
      status,
      search,
      id,
      appTypeVisible,
      applyPeople,
      tags
    } = this.state;
    const { orgOptions } = this.props;
    return (
      (<Translation>{t => {
          return (
            (<div>
              <div className="breadcrumbTop py-2">
                <Breadcrumb>
                  <Breadcrumb.Item>{t("内容")}</Breadcrumb.Item>
                  <Breadcrumb.Item>{t("消息")}</Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{padding: "32px 0 11px 0"}}>
                    <Space>
                        <img src="/images/contentnoticeIcon.svg" alt="" />
                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("消息")}</span>
                    </Space>
                </Row>
              </div>
              <Spin spinning={false}>
                <Row style={{ width: "100%" }}>
                  <div className="borderBox">
                    <Row className="mb-3">
                      <Col>
                        {t("消息标题")}:
                        <Input
                          style={{ width: "200px", marginLeft: 10 }}
                          placeholder={t("输入消息标题搜索")}
                          value={search}
                          onChange={(e) => this.setState({ search: e.target.value })}
                        ></Input>
                      </Col>

                      <Col offset={1}>
                        <Button type="primary" onClick={this.onSearch}>
                          {t("查询")}
                        </Button>
                      </Col>

                    </Row>
                  </div>
                  <div className="borderBox">
                    <Row style={{ marginBottom: 8 }}>
                      <Col className="ms-auto">
                        <Button
                          type="primary"
                          onClick={() => { this.setState({ isModalVisible: true }); gaEvent("notification", "onClick", "添加消息") }}
                        >
                          <PlusOutlined />
                          {t("添加消息")}
                        </Button>
                      </Col>
                    </Row>
                    <Table
                      size="middle"
                      loading={loading}
                      dataSource={data}
                      pagination={false}
                      onChange={(pagination) => { }}
                      locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                    >
                      <Column key="title" dataIndex="title" title={t("消息标题")}></Column>
                      <Column
                        key="content"
                        dataIndex="content"
                        title={t("消息内容")}
                      ></Column>
                      <Column
                        key="status"
                        dataIndex="status"
                        title={t("状态")}
                        render={(v) => (
                          <> 
                            {v=="Active"&&(
                              <span><CheckCircleFilled  style={{color:"#4CB8BE",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                            )}
                            {v=="Disabled"&&(
                              <span><StopFilled  style={{color:"#C9A063",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                            )}
                          </>
                        )}
                      ></Column>
                      <Column
                        key="updateTime"
                        dataIndex="updateTime"
                        title={t("更新时间")}
                      // render={(v) => v?.slice(10)}
                      ></Column>

                      <Column
                        key="operation"
                        dataIndex="id"
                        title={t("操作")}
                        render={(v: string, d: any) => {
                          return (
                            <Space size={8}>
                              <Button type="link" size="small" onClick={() => { this.onEdit(d); gaEvent("notification", "onClick", "onEdit") }}>
                                {t("编辑")}
                              </Button>
                              <Popconfirm
                                title={`${t("确认删除消息")} ${d.title}？`}
                                onConfirm={() => this.onDelete(v)}
                                okText={t("确认")}
                                cancelText={t("取消")}
                              >
                                <Button type="link" ghost size="small">
                                  {t("删除")}
                                </Button>
                              </Popconfirm>
                              <Button type="link" size="small" onClick={() => { this.getAppSelfService(v); gaEvent("docs", "onClick", "自助服务") }}>
                                {t("自助服务")}
                              </Button>
                            </Space >
                          );
                        }}
                      ></Column>
                    </Table>
                    <Pagination
                      style={{ textAlign: "right", marginTop: "20px" }}
                      pageSize={pageSize}
                      current={pageIndex}
                      total={totalCount}
                      showTotal={(total, range) =>
                        `${range[0]}-${range[1]} / ${total} ${t("条")}`
                      }
                      onChange={(page, pageSize) => {
                        this.getList(page, pageSize);
                      }}
                      onShowSizeChange={(current, size) => this.getList(current, size)}
                    ></Pagination>
                  </div>
                </Row>
              </Spin>
              <Modal
                maskClosable={false}
                title={id ? t("编辑消息") : t("添加消息")}
                destroyOnClose={true}
                confirmLoading={loading}
                open={isModalVisible}
                onOk={() => this.onOk()}
                onCancel={() => this.onCancel()}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Row gutter={24}>
                  <Col span={24}>
                    <label htmlFor="">{t("消息标题")}</label>
                    <div>
                      <Input
                        placeholder={t("消息标题")}
                        value={title}
                        onChange={(e) => this.setState({ title: e.target.value })}
                      ></Input>
                    </div>
                  </Col>
                  <Col span={24} className="mt-3">
                    <label htmlFor="">{t("消息内容")}</label>
                    <div>
                      <Input.TextArea
                        value={detail}
                        onChange={(e) => this.setState({ detail: e.target.value })}
                      ></Input.TextArea>
                    </div>
                  </Col>
                  <Col span={24} className="mt-3">
                    <label htmlFor="">{t("状态")}</label>
                    <div>
                      <Select
                        value={status}
                        onChange={(v) => this.setState({ status: v as any })}
                      >
                        <Select.Option value="Active"> {t("正常")}</Select.Option>
                        <Select.Option value="Disabled"> {t("禁用")}</Select.Option>
                      </Select>
                    </div>
                  </Col>
                </Row>
              </Modal>
              <Modal
                confirmLoading={loading}
                maskClosable={false}
                open={appTypeVisible}
                destroyOnClose={false}
                title={t("自助服务")}
                width={"650px"}
                onOk={() => {
                  this.applyGroupOk()
                }}
                onCancel={() => {
                  this.setState({ appTypeVisible: false, applyPeople: "" })
                  this.formRef.current?.resetFields()
                }}
              >
                <Form style={{ width: "90%", marginTop: 36 }}
                  layout="horizontal"
                  ref={this.formRef}
                  // labelCol={{ span: 3 }}
                  initialValues={{ type: "None" }}>
                  {/* <Form.Item label="应用分类" name="status" rules={[{ required: false }]} >
                    <Select>
                      <Select.Option value="1">效率</Select.Option>
                    </Select>

                  </Form.Item> */}
                  <Form.Item label={t("适用人群")} name="type" rules={[{ required: false }]} >
                    <Select allowClear placeholder={t("未选择")} onChange={(e) => {
                      this.setState({ applyPeople: e + "" })
                      this.formRef.current?.setFieldsValue({
                        Organization: [],
                        tags: []
                      })
                    }}>
                      <Select.Option value="None">{t("未选择")}</Select.Option>
                      <Select.Option value="All">{t("全部")}</Select.Option>
                      {/* <Select.Option value="Organization">{t("部门")}</Select.Option> */}
                      <Select.Option value="Tag">{t("设备组")}</Select.Option>
                    </Select>
                  </Form.Item>
                  {/* {applyPeople == "Organization" && (
                    <Form.Item label={t("选择部门")} name="Organization" rules={[{ required: false }]} >
                      <TreeSelect treeData={orgOptions} treeDefaultExpandAll></TreeSelect>
                    </Form.Item>
                  )} */}
                  {applyPeople == "Tag" && (
                    <Form.List name="tags">
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map((field) => (
                            <Form.Item key={field.key} labelCol={{ span: 3 }} label={t("设备组")}>
                              <Row justify="space-between">
                                <Col span="21">
                                  <Form.Item noStyle
                                    {...field}
                                    name={[field.name, "tag"]}
                                    // fieldKey={[field.fieldKey, "tag"]}
                                  >
                                    <Cascader options={tags} />
                                  </Form.Item>
                                </Col>
                                <Col>
                                  <Button type="dashed" onClick={() => { remove(field.name); gaEvent("deviceAdd", "onClick", "remove") }}>-</Button>
                                </Col>
                              </Row>
                            </Form.Item>
                          ))}
                          <Form.Item wrapperCol={{ offset: 3 }}>
                            <Button type="dashed" onClick={() => { add(); gaEvent("deviceAdd", "onClick", "add") }} block>
                              {t("添加设备组")}
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>
                  )}
                </Form>
              </Modal>
            </div>)
          );
        }}</Translation>)
    );
  }
}

export default connect(mapStatetoProps, {})(DocListPage);
